var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPaperJam = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128",
  width: 128
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M16.15 32.02c5.05 0 9.15 4.11 9.15 9.15 0 5.05-4.11 9.15-9.15 9.15S7 46.22 7 41.18c0-5.05 4.11-9.16 9.15-9.16m0-6C7.78 26.02 1 32.81 1 41.18c0 8.37 6.78 15.15 15.15 15.15S31.3 49.55 31.3 41.18c.01-8.37-6.78-15.16-15.15-15.16zm0 52.67c5.05 0 9.15 4.11 9.15 9.15S21.2 97 16.15 97 7 92.89 7 87.85s4.11-9.16 9.15-9.16m0-6C7.78 72.69 1 79.48 1 87.85S7.78 103 16.15 103 31.3 96.22 31.3 87.85s-6.78-15.16-15.15-15.16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0075c2",
  strokeWidth: 6,
  strokeLinejoin: "round",
  d: "M17.56 64.24h17.02l11.17 11.78L60.1 33.2l20.74 62.63 9.04-31.58h37.75"
})));
export default SvgPaperJam;